import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddVendorServicesComponent } from 'src/app/components/setup/vendor-services/addvendorservices.component';
import { AccountManagementComponent } from 'src/app/components/setup/vendors/account-management/account-management.component';
import { AddVendorComponent } from 'src/app/components/setup/vendors/add/addvendor.component';
import { APIConfigComponent } from 'src/app/components/setup/vendors/api-config/api-config.component';
import { EditVendorComponent } from 'src/app/components/setup/vendors/edit/editvendor.component';
import { ListVendorComponent } from 'src/app/components/setup/vendors/list/listvendor.component';

const routes: Routes = [
  { path: '', component: ListVendorComponent },
  { path: 'add', component: AddVendorComponent },
  { path: 'edit/:id', component: EditVendorComponent },
  { path: ':id/services', component: AddVendorServicesComponent },
  { path: ':id/services', component: AddVendorServicesComponent },
  { path: ':id/accountmanagement', component: AccountManagementComponent },
  { path: ':id/apiconfiguration', component: APIConfigComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes),],
  exports: [RouterModule]
})
export class VendorsRoutingModule { }
